// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__vyxQC","spinner":"loading_spinner__5quHg","Shimiring":"loading_Shimiring__BVQ3s"};